import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=7dafca96&scoped=true&"
import script from "./Delivery.vue?vue&type=script&lang=ts&"
export * from "./Delivery.vue?vue&type=script&lang=ts&"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=7dafca96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dafca96",
  null
  
)

export default component.exports